/**
 * Erenown — Theme 1 (Observatory) shared tokens.
 * Theme 2 (Monumental) contributes only the warm accent and signature display type,
 * used selectively on the brand reveal and The Brand page.
 */
export const T = {
  bg:        "#080A0E",
  surface:   "#0F1218",
  surface2:  "#141922",
  surface3:  "#1B2130",
  text:      "#E7ECEF",
  textSoft:  "#B8C0C6",
  muted:     "#6E7781",
  mutedSoft: "#9AA4AD",
  border:    "#1E2530",
  borderSoft:"#2A3340",
  accent:    "#A9C8D8",   // ice-blue — Theme 1 primary
  accentDim: "#6E8D9C",
  warm:      "#E6A55A",   // warm accent — inspired by Theme 2, used selectively
  warmSoft:  "#B57F3E",
};
